<template>
    <v-alert
            :color="type"
            elevation="2"
            dense
            :class="['info-alert', maxWidth ? 'info-alert--width' : '']"
    >
        <div class="info-alert__content">
            <div class="info-alert__header">
                <div class="info-alert__title">
                    <v-icon size="1.8rem" color="black" class="mr-2">{{ icon }}</v-icon>
                    <slot name="title">
                        <span :class="[ 'advice_friendly--text']">
                            {{ title }}
                        </span>
                    </slot>
                </div>
            </div>

            <div class="info-alert__desc advice_friendly--text">
                <slot />
            </div>
        </div>
    </v-alert>
</template>

<script>
  export default {
    name: 'Banner',
    props: {
      type: {
        type: String,
        default: 'info',
        validator: v => ['info', 'warning', 'error', 'success'].includes(v)
      },
      icon: {
        type: String,
        default: 'mdi-information'
      },
      title: {
        type: String,
        default: ''
      },
      maxWidth: {
        type: Boolean,
        default: true
      }

    }
  }
</script>

<style scoped>
.info-alert {
    margin-bottom: 16px;
    border-radius: 8px;

    justify-self: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.info-alert--width{
    max-width: 800px;
}
.info-alert__content {
    display: flex;
    flex-direction: column;
    padding:5px 3px;
}
.info-alert__header {
    display: flex;
    align-items: center;
    margin-bottom: 0.8rem;
}

.info-alert__title {
    font-weight: 900;
    font-size: 1.4rem;
    margin: 0;
    display: flex;
    align-items: center;
    color: #333;
}
.info-alert__desc {
    font-size: 1.2rem;
    line-height: 1.5;
    color: #555;
}

</style>
